// import { WebBeacon } from '@wow/web-beacon'
import WebBeacon from './WebBeacon'

export default WebBeacon
